/**
 * Данные, из которых считается всё остальное (аналог журналов Ж_Запросы / Ж_Закупки / Ж_Склад).
 * Даты — строки «ГГГГ-ММ-ДД» (день по Москве), моменты времени — ISO 8601.
 */
/** Данные груза, которые переходят из прошлой упаковки OEM в новую. */
export const WAREHOUSE_ATTRS = ['marking', 'series', 'maker', 'hs', 'material'];
//# sourceMappingURL=types.js.map